import { render } from "./showOrders.vue?vue&type=template&id=adf03782&scoped=true"
import script from "./showOrders.vue?vue&type=script&lang=js"
export * from "./showOrders.vue?vue&type=script&lang=js"

import "./showOrders.vue?vue&type=style&index=0&id=adf03782&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf03782"]])

export default __exports__